module.exports = __webpack_public_path__ + "img/remove-icon.4a5b461f.svg";